// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { FormItem, IFormInstance } from '@/components';
import { Button, Input } from '@/ui';
import { StyledForm } from './PushOrderFormStyles';

// Helpers
import { PushOrderFormFields, TPushOrderFormValues } from '../../helpers';
import { usePushOrderFormRules } from '../../hooks';

type TPushOrderFormProps = {
  onSubmit: (values: TPushOrderFormValues) => void;
  isLoading?: boolean;
  className?: string;
  form: IFormInstance;
};

const PushOrderForm: FC<TPushOrderFormProps> = ({ onSubmit, className, form, isLoading }) => {
  const { t } = useTranslation();
  const rules = usePushOrderFormRules();

  return (
    <StyledForm form={form} className={className} onFinish={onSubmit}>
      <FormItem
        rules={rules[PushOrderFormFields.ORDER_ID]}
        name={PushOrderFormFields.ORDER_ID}
        extra={<p>{t('push_order_help')}</p>}
        label={t('label_order_id')}
      >
        <Input />
      </FormItem>
      <Button htmlType="submit" type="primary" loading={isLoading}>
        {t('btn_push')}
      </Button>
    </StyledForm>
  );
};

export default PushOrderForm;
